<template>
  <photo-evidences
    :photo-file-types="generatorTypes"
    slot="body"
    :affectedId="affectedId"
    @hasRequiredPhotos="hasRequiredPhotos = $event"
    :no-image-actions="isExtranet"
    :is-extranet="isExtranet"
    :check-date="checkDate"
    v-if="affectedId"
    :realPlan="realPlan"
    :read-only="readOnly"
    :isES="true"
    :isCP="true"
  >
    <template slot="tabs-start" slot-scope="{ fileTypes, concepts }">
      <tab name="Descargar Formatos" v-if="!isExtranet && !readOnly">
        <md-table>
          <md-table-row>
            <md-table-head>Concepto</md-table-head>
            <md-table-head>Generador diario</md-table-head>
            <md-table-head>Generador final</md-table-head>
          </md-table-row>
          <md-table-row :key="concept.id" v-for="concept in concepts">
            <md-table-cell md-label="Concepto">{{ concept.name }}</md-table-cell>
            <md-table-cell md-label="Generador diario">
              <md-button
                @click="downloadWorkGenerator(concept.id, 'daily')"
                class="md-info md-just-icon"
                :disabled="
                  !$can(
                    'can_download_work_generator_daily',
                    'Quantification',
                    'quantification'
                  )
                "
              >
                <md-icon>cloud_download</md-icon>
              </md-button>
            </md-table-cell>
            <md-table-cell md-label="Generador final">
              <md-button
                @click="downloadWorkGenerator(concept.id, 'final')"
                class="md-primary md-round md-just-icon"
                :disabled="
                  !$can(
                    'can_download_work_generator_final',
                    'Quantification',
                    'quantification'
                  )
                "
              >
                <md-icon>cloud_download</md-icon>
              </md-button>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </tab>
    </template>
  </photo-evidences>
</template>

<script>
import PhotoEvidences from "./PhotoEvidences";
import purchaseService from "@/services/purchase";
import { TASK_STATUS_ICONS } from "./WeeklyExecution/utils";

const GENERATORS_TYPES = [
  {
    fileCode: "GOD",
    required: true,
    missingFileLabel: "#Gen",
    showLabels: true,
    regularFile: true,
    isDiaryFile: true,
  },
  {
    fileCode: "BTC",
    required: true,
    missingFileLabel: "#Bit",
    noConceptGrouping: true,
    showLabels: true,
    regularFile: true,
    isDiaryFile: true,
  },
  {
    fileCode: "GOF",
    required: true,
    missingFileLabel: "#GenFin",
    showLabels: true,
    regularFile: true,
  },
  {
    fileCode: "BTCF",
    required: true,
    missingFileLabel: "#BitFinal",
    noConceptGrouping: true,
    showLabels: true,
    regularFile: true,
  },
];

export default {
  name: "GeneratorsModal",

  props: {
    affectedId: {
      type: Number,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    isExtranet: {
      default: false,
      type: Boolean,
    },
    checkDate: {
      type: String,
      required: false,
    },
    hideDiaryFiles: {
      type: Boolean,
      default: false,
    },
    realPlan: {
      type: Object,
      default: false,
    },
  },

  computed: {
    headerClass() {
      return "";
      /* return 'md-warning' */
    },
  },

  components: {
    PhotoEvidences,
  },

  methods: {
    close() {
      this.$emit("close");
    },
    downloadWorkGenerator(qId, type) {
      purchaseService
        .getWorkGenerator(qId, type)
        .then((resp) => this.$successMessage({ title: `Archivo descargado` }))
        .catch(this.$fireErrorResponse);
    },
  },

  data() {
    const generatorTypes = !this.hideDiaryFiles
      ? GENERATORS_TYPES
      : GENERATORS_TYPES.filter(({ isDiaryFile }) => !isDiaryFile);
    return {
      securityPhotos: [],
      generatorTypes,
      hasRequiredPhotos: null,
    };
  },
  watch: {
    hasRequiredPhotos: {
      immediate: true,
      handler(value) {
        this.$emit("hasRequiredPhotos", value);
      },
    },
  },

  filters: {
    planIcon(status) {
      return TASK_STATUS_ICONS[status] || "visibility";
    },
    statusMessage(evidencesStatus) {
      if (evidencesStatus) {
        return "Tiene todas los generadores";
      } else if (evidencesStatus === false) {
        return "Faltan generadores";
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/pages/WorkPlan/Generators.vue